import { Grid, styled } from '@mui/material';

export const StyledSongItemContainer = styled(Grid)(({ theme }) => ({
  background: theme.palette.grey[800],
  padding: theme.spacing(2, 0),
}));
StyledSongItemContainer.defaultProps = {
  container: true,
  item: true,
  alignItems: 'center',
};
